import React from 'react'
import CSSModules from 'react-css-modules'
import { Relayout, RelayoutItem } from 'relayout'

import styles from './promo-code-list-empty.css'


const PromoCodeListEmpty = () => (
  <Relayout key="promo-codes-empty">
    <RelayoutItem sm="12" lg="12">
      <div styleName="item">No promo codes are set up yet.</div>
    </RelayoutItem>
  </Relayout>
)

export default CSSModules(PromoCodeListEmpty, styles)



/** WEBPACK FOOTER **
 ** ./src/components/promo-code-list/promo-code-list-empty/promo-code-list-empty.js
 **/